module.exports = {"410403001":"东安路街道","410403002":"优越路街道","410403003":"五一路街道","410403004":"建设路街道","410403005":"东环路街道","410403006":"东工人镇街道","410403007":"光华路街道","410403008":"鸿鹰街道","410403009":"申楼街道","410403010":"北环路街道","410403011":"东高皇街道","410403012":"蒲城街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410403.json
// module id = 1427
// module chunks = 0